import { Roles } from '@/auth/azure/Roles'
import RouterErrorHandler from '@/components/RouterErrorHandler'
import { Auto } from '@/routes/admin/users/auto/Auto'
import { TileRoleRoute } from '@/types'
import { faCar } from '@fortawesome/free-solid-svg-icons'

export const AutoRoute = {
  path: 'auto',
  text: 'Automobili',
  element: <Auto />,
  mainMenuRoute: false,
  faIcon: faCar,
  errorElement: <RouterErrorHandler />,
  handle: {
    crumb: () => ({
      label: 'Automobili',
      icon: faCar,
    }),
  },
  tile: true,
  allowedRoles: [Roles.GlobalAdministrator, Roles.Administrator],
} satisfies TileRoleRoute
